/**
 * External dependencies
 */
import { omit } from 'lodash';
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import { START_EDITING_LOCATION } from 'state/action-types';

import { createReducer } from 'state/utils';

export const locationId = createReducer(null, {
    [START_EDITING_LOCATION]: (state, { payload }) => payload.locationId,
});

export default combineReducers({
    locationId,
});
